import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';

import STORES from 'constants/store';

const StoreAvatar = ({ gaEventCategory, storeDomain, storeImage, ...rest }) => (
  <Flex
    display={['none', null, 'flex']}
    onClick={() =>
      sendEvent({
        action: 'store',
        category: gaEventCategory,
      })
    }
    {...rest}
  >
    <Avatar
      size="size4"
      src={storeImage}
      description={storeDomain}
      iconComponent={<Icon name="store" />}
    />
    <Flex flexDirection="column" justifyContent="center" ml={2}>
      <Text size="size3">{STORES.DESCRIPTION_OFFER_STORE}</Text>
      <Text size="size3" bold>
        {storeDomain}
      </Text>
    </Flex>
  </Flex>
);

StoreAvatar.defaultProps = {
  storeImage: null,
};

StoreAvatar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  storeDomain: PropTypes.string.isRequired,
  storeImage: PropTypes.string,
};

export default StoreAvatar;
